<div id="legals" class="page py-4">
  <div class="container pt-3">
    <div class="terms-container">
      <div class="row mb-4">
        <div class="col">
          <div class="content pt-4 pt-md-0">
            <h1>Términos y Condiciones</h1>
            <hr class="separator" />
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col">
          <div class="content">
            <!-- #######  THIS IS A COMMENT - Visible only in the source editor #########-->
            <p>
              Kybernus A.C es una asociación civil sin fines de lucro, que entre
              sus propósitos se encuentra crear una red de líderes que permita
              mantener una constante comunicación entre los participantes del
              programa, para lo cual, te agradeceremos que observes con
              detenimiento el presente documento.<br />
              <br />
              <strong>Aceptación:</strong><br />
              Los presentes términos y condiciones de uso regulan el acceso y
              uso del portal https://kybernus.org/ así como de todos sus
              servicios y aplicaciones. La plataforma digital se pone a tu
              disposición, a condición de que aceptes los términos y condiciones
              que aquí se establecen.<br />
              <br />
              Cuando aceptas registrarte en https://kybernus.org/ o al utilizar
              nuestro sitio web, así como cualquier aplicación o herramienta que
              pongamos a tu disposición por este medio, suscribes un contrato
              jurídicamente vinculante con Kybernus Asociación Civil, con
              domicilio en PERIFÉRICO SUR 4225-602 / 603. COL. JARDINES DE LA
              MONTAÑA-MÉXICO DF. 14210 de conformidad con los términos de estas
              Condiciones de uso y del Aviso de Privacidad que ponemos a tu
              disposición, el cual se incorpora por referencia a las presentes
              Condiciones de uso (en adelante referidas conjuntamente como el
              “Contrato”) y te conviertes en usuario de la plataforma digital
              (en adelante “usuario”).<br />
              <br />
              Si estás utilizándola en nombre de una empresa o de otra entidad
              jurídica, estarás vinculado jurídicamente como persona física por
              el presente Contrato incluso aunque tu empresa o entidad jurídica
              haya suscrito un contrato independiente con nosotros. Si no deseas
              registrar una cuenta y convertirte en usuario, no suscribas este
              Contrato, NO hagas clic en “Aceptar” y no accedas, mires,
              descargues o utilices de cualquier otro modo el sitio web, la
              información o los servicios de Kybernus A.C. Al hacer clic en
              "Aceptar" (o una frase similar), aceptas haber leído y comprendido
              los términos y condiciones de este Contrato y aceptas estar
              obligado a cumplir todas sus disposiciones.<br />
              <br />
              Al hacer clic en "Aceptar" también otorgas tu consentimiento para
              usar las firmas electrónicas y reconoces el acto de pulsar el
              botón de "Aceptar" como uno de dichos usos. Ten en cuenta que las
              Condiciones de uso y el Aviso de Privacidad de Kybernus A.C.,
              también se denominan conjuntamente “Condiciones del Servicio” de
              Kybernus A.C.<br />
              <br />
              <strong>Tus derechos:&nbsp;</strong><br />
              Con la condición de que cumplas con todas las obligaciones en
              virtud de este Contrato, te otorgamos un derecho limitado,
              revocable, no exclusivo, no sujeto a cesión o sublicencia, para
              acceder, a través de un navegador de red disponible, dispositivo
              móvil o aplicación autorizada por Kybernus A.C., (que no sea una
              tecnología del tipo scraping, spidering, crawling o similar, o un
              software utilizado para acceder a datos sin el consentimiento
              expreso por escrito de Kybernus A.C., o de sus usuarios) a
              visualizar información y utilizar los servicios de la plataforma
              digital que ponemos a tu disposición, de conformidad con lo
              dispuesto en este Contrato.<br />
              <br />
              Cualquier otro uso de la plataforma digital contrario a nuestra
              misión y finalidad (como intentar conectarte con alguien en quien
              no confías o utilizar información recabada por Kybernus A.C., para
              fines comerciales, salvo autorización expresa y por escrito) está
              terminantemente prohibido e incumple el presente Contrato. Nos
              reservamos todos los derechos no otorgados expresamente en el
              presente Contrato, incluidos entre otros, los derechos de
              titularidad, de propiedad, propiedad intelectual y todos los demás
              derechos e interés en la plataforma digital.&nbsp;<br />
              <br />
              <strong>Vigencia:</strong><br />
              El presente Contrato será vigente en tanto no manifiestes tu deseo
              de dar por terminado el vínculo jurídico aquí contenido o bien, en
              tanto no incumplas a cualquier obligación aquí contenida.&nbsp;<br />
              <br />
              <strong>Propiedad intelectual e industrial:</strong><br />
              El derecho de acceso al presente sitio web se limita
              exclusivamente a navegar por el mismo y así como a utilizar los
              servicios que ofrecemos. El material, la información, el logotipo,
              el software, las herramientas y servicios de este sitio no podrán
              ser objeto de modificación, copia, muestra, presentación,
              licenciamiento, reproducción, publicación, carga, envío,
              transmisión o distribución, o cualquier otra figura legal que
              involucre la transmisión de la posesión del contenido propiedad de
              Kybernus A.C. Toma en cuenta que las ideas que publiques y la
              información que compartas pueden ser vistas y usadas por otros
              usuarios, y Kybernus A.C., no puede garantizar que otros usuarios
              no utilicen las ideas e información que aquí compartas.<br />
              <br />
              Por lo tanto, si tienes una idea o información que deseas mantener
              confidencial o no quieres que sea utilizada por otras personas, o
              si está sujeta a derechos de terceros que podrían ser infringidos
              si la compartieras, no la publiques en ningún grupo, ni en
              actualizaciones de la plataforma ni en ninguna otra parte del
              sitio de Kybernus A.C. Por lo anterior Kybernus A.C., no se
              responsabiliza por el uso o apropiación indebida de cualquier
              contenido o información que publiques en su sitio web.&nbsp;<br />
              <br />
              <strong>Uso ilegal:</strong><br />
              Los servicios de Kybernus A.C., pueden ser utilizados únicamente
              para propósitos lícitos. La transmisión, almacenaje o distribución
              de cualquier información, datos o material en violación de
              cualquier ley o regulación aplicable está prohibida.<br />
              <br />
              Esto incluye, aunque no está limitado, a material registrado,
              marcas registradas, secretos comerciales u otros derechos de
              propiedad intelectual usados sin la apropiada autorización;
              material obsceno, difamatorio o que constituye un fraude, o que
              viola los controles legales de exportación.&nbsp;<br />
              <br />
              <strong>Seguridad:</strong><br />
              Las violaciones a la seguridad de la red están prohibidas, sin
              perjuicio de la responsabilidad legal objetiva o subjetiva que
              pudiera generarse. De forma indicativa mas no limitativa, está
              prohibido y penado: El acceso no autorizado al servidor y/o probar
              o escanear las medidas de seguridad o autenticación, datos,
              tráfico, interferencia con el servicio a cualquier usuario del
              servidor o de cualquier red incluida sin limitación, bombardeo de
              correos (mail bombing), inundación (flooding), atentados
              deliberados a sobrecargar un sistema, ataques de difusión
              (broadcast), negación de servicios (dos), negación distribuida de
              servicios (ddos).<br />
              <br />
              También se considera una violación al principio de Seguridad si el
              o los usuarios mantienen negligentemente passwords inseguros en
              sus computadores o sin antivirus actualizados y/o scripts,
              formularios o programas no actualizados con los últimos parches de
              seguridad, que de forma directa y/o indirecta permitan que
              terceros utilicen su computador o cuentas de email o sus scripts,
              formularios o sus programas instalados en sus computadores y/o
              website para el envío de email masivos, sean estos de carácter
              propagandístico o fraudulentos como el Phishing, Pharming o
              análogos, sean con la intención o no de defraudar a terceros, sin
              perjuicio de la responsabilidad administrativa, civil y penal que
              corresponda.<br />
              <br />
              Por lo anterior, en caso de verificarse el cumplimiento de alguno
              de los supuestos antes señalados, o de cualquier otros que
              conlleve a la violación de los estándares de seguridad, facultará
              a Kybernus A.C., para ejercer las vías legales que considere
              pertinentes.&nbsp;<br />
              <br />
              <strong>Reservas:</strong><br />
              El usuario declara y garantiza que ha cumplido los dieciocho años
              de edad y cuenta con absoluta capacidad legal para utilizar este
              sitio web así como para obligarse y contratar los términos y
              condiciones aquí señalados. Como usuario eres consciente de las
              repercusiones legales en las que puedes incurrir al incumplir con
              las disposiciones aquí contenidas así como violar los derechos de
              los demás usuarios. Así mismo, aceptas que eres el único
              responsable del resguardo de tu clave de acceso (password) por lo
              que en caso de que reveles, transfieras, vendas, cedas o realices
              cualquier acto que conlleve a la transmisión de la posesión o
              revelación de la información, liberas a Kybernus A.C., de
              cualquier responsabilidad legal que se derive de dichos
              actos.&nbsp;<br />
              <br />
              <strong>Garantías:</strong><br />
              Kybernus A.C., no se responsabiliza ni ofrece garantías de ningún
              tipo con respecto a: el contenido del sitio web de Kybernus A.C;
              los materiales, la información o las funciones a las cuales se
              obtenga acceso por medio del software utilizado en el sitio web o
              al cual se obtenga acceso a través del sitio de Kybernus A.C; todo
              producto o servicio de terceros o enlaces a terceros; o toda
              violación a la seguridad asociada con la transmisión de
              información sensible a través del sitio de Kybernus A.C., o algún
              sitio enlazado.<br />
              <br />
              No garantizamos que las funciones y/o herramientas contenidas en
              el sitio o algún material o contenido del mismo estarán libres de
              interrupciones o errores, que todos los defectos se corregirán, o
              que o el servidor en el cual funciona está libre de virus u otros
              componentes perjudiciales. No aceptamos ninguna responsabilidad
              por alguna pérdida o daño, incluidos y sin limitaciones, pérdidas
              o daños indirectos, especiales, o directos, que resulten del uso
              de la plataforma digital independientemente de si éstos ocurren a
              consecuencia de algún acto negligente u omisión.<br />
              <br />
              En caso que Kybernus A.C., se reserva el derecho a denegar o
              cancelar el registro con o sin notificación previa si el usuario
              incurre en cualquier conducta o actividad que se considere abuso o
              violación de alguno de los términos, normas y condiciones aquí
              expuestas, con o sin previo aviso y sin responsabilidad
              alguna.&nbsp;<br />
              <br />
              <strong>Terminación del contrato:</strong><br />
              Podrás terminar el presente Contrato, sin justificación de causa y
              en cualquier momento, tras notificarlo a Kybernus A.C., mediante
              las herramientas que ponemos a tu disposición. En caso de desear
              dar por terminado este contrato aceptas que tu cuenta de usuario y
              clave de acceso serán desactivados permanentemente cuando tu
              solicitud se haya procesado.<br />
              <br />
              Modificación de las presentes Condiciones de Uso En lo que se
              refiere a los mensajes y las notificaciones sobre los Servicios,
              Kybernus A.C., podrá publicar un aviso en forma de banner en su
              página para avisarte sobre determinados cambios como
              modificaciones incorporadas al presente Contrato. Como
              alternativa, el aviso podrá consistir en un correo electrónico de
              Kybernus A.C., enviado a una de las direcciones asociadas a tu
              cuenta, incluso aunque tengamos otra información de contacto.
              Asimismo, consientes en que Kybernus A.C., pueda ponerse en
              contacto contigo a través de tu cuenta Kybernus A.C., o por otros
              medios incluidos tu correo electrónico, tu número de teléfono
              móvil o fijo o mediante servicios de entrega como el correo postal
              en relación con tu cuenta Kybernus A.C., o los servicios asociados
              a la plataforma digital.<br />
              <br />
              Manifiestas conocer y aceptas que no asumiremos ninguna
              responsabilidad asociada con o derivada de no mantener tus datos
              de contacto u otra información actualizada, incluida sin que
              suponga limitación, la no recepción por tu parte de información
              importante sobre el Servicio. Este Contrato está disponible
              únicamente en español.<br />
              <br />
              El documento electrónico específico en que se formalice su
              contrato con Kybernus A.C., no será archivado individualmente. La
              última versión del presente contrato estará disponible en todo
              momento a través del sitio web https://kybernus.org/&nbsp;<br />
              <br />
              <strong>Jurisdicción y Ley Aplicable:</strong><br />
              Para la resolución de cualquier tipo de controversia el usuario y
              Kybernus A.C., se someten a la jurisdicción de las leyes y
              tribunales competentes de la Ciudad de México, Distrito Federal, y
              con exclusión de toda norma sobre conflictos de leyes, renunciando
              a cualquier fuero que por motivo de domicilio presente o futuro,
              pudiera corresponderles.&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
